import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function EmailTemplatePage() {
  return (
    <MainLayout>
      <SEO 
        title="Modelo de e-mail de venda"
        description="Configure modelo de e-mail de venda"
        keywords="e-mail, modelo, venda, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Modelo de e-mail de venda</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

